import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('admin/menu', ['menuMap'])
  },
  methods: {
    allow(id) {
      const { funcID } = this.$route.meta || {}
      const menu = this.menuMap[funcID]
      const btnRoles = menu ? menu.btnFunc || [] : []
      return btnRoles.find((item) => item.buttonID === id)
    }
  }
}
